<template>
    <div class="snapshot_pc standard" :style="containerStyle">
        <div v-show="showMarketReportData || showMarketComing">
            <div class="board_container">
                <ul class="board">
                    <li>
                        <snap-circle
                            :params="soldListing"
                            :hasRecentSold="hasRecentSold"
                        />
                    </li>
                    <li>
                        <snap-circle
                            :params="avgSalePrice"
                            :hasRecentSold="hasRecentSold"
                        />
                    </li>
                    <li>
                        <snap-circle
                            :params="avgDaysOnMarket"
                            :hasRecentSold="hasRecentSold"
                        />
                    </li>
                </ul>
                <div
                    class="loading_container"
                    v-show="showMarketReportLoading || showMarketComing"
                >
                    <Loading />
                </div>
            </div>
        </div>
        <!-- <div class="coming_container" v-show="showMarketComing">
        <img
            class="pic"
            src="//static.chimeroi.com/image/snapshot/v3-img-no-market@2x.png"
            alt=""
        />
        <div class="desc">coming soon</div>
    </div> -->
        <div class="location_tips_container" v-show="showMarketNoLocation">
            <img
                class="pic"
                src="//static.chimeroi.com/image/snapshot/v3-img-no-market@2x.png"
                alt
            />
            <div class="desc">
                {{ $t('md-snapshot-search.pleaseInputAValid') }}
            </div>
        </div>
        <div class="no_data" v-show="showMarketNoData">
            <img
                class="pic"
                src="//static.chimeroi.com/image/snapshot/v3-img-no-market@2x.png"
                alt
            />
            <div class="desc">
                {{ noDataText }}
            </div>
        </div>
    </div>
</template>

<script>


import { mapState, mapActions } from '@/store/helpers';


import Circle from './circle.vue';
import Loading from '../../../../../components/loading';

import MoreBtnCommon from '../../../_mixins/more-btn/common';

export default {
    components: { 'snap-circle': Circle, Loading },
    name: 'report-pc',
    props: {
        soldListing: {
            required: true
        },
        avgSalePrice: {
            required: true
        },
        avgDaysOnMarket: {
            required: true
        }
    },
    mixins: [MoreBtnCommon],
    computed: {
        ...mapState({
            "showMarketReportData": "showMarketReportData",
            "showMarketReportLoading": "showMarketReportLoading",
            "showMarketNoLocation": "showMarketNoLocation",
            "showMarketComing": "showMarketComing",
            "showMarketNoData": "showMarketNoData"
        }),
        // container  style of
        containerStyle() {
            return { height: `${this.needMore ? 475 : 375}px` };
        },
        hasRecentSold() {
            return this.soldListing?.status !== 3;
        }
    }
};
</script>

<style lang="scss">
.snapshot_pc.standard {
    font-family: var(--font-normal);
    box-sizing: border-box;
    border-radius: 4px;
    position: relative;
    box-shadow: 0px 0 5px 0 rgba(0, 10, 30, 0.1);
    background-color: #ffffff;
    padding: 60px 40px;
    .board_container {
        position: relative;
        .board {
            width: 100%;
            display: flex;
            justify-content: space-between;
            &.center {
                justify-content: center;
            }
        }
        .loading_container {
            position: absolute;
            left: 0;
            right: 0;
            top: 0;
            bottom: 0;
            z-index: var(--level-low);
            background: rgba(255, 255, 255, 0.6);
            display: flex;
            justify-content: center;
            align-items: center;
        }
    }
    .more {
        background-color: var(--color-theme);
        width: 343px;
        height: 40px;
        line-height: 40px;
        margin: 0 auto;
        margin-top: 60px;
        font-size: 16px;
        color: #ffffff;
        display: flex;
        align-content: center;
        justify-content: center;
        p {
            display: flex;
            align-items: center;
            justify-content: center;
        }
    }
    .coming_container,
    .location_tips_container,
    .no_data {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        .pic {
            width: 220px;
            height: 130px;
        }
        .desc {
            margin-top: 20px;
            font-size: 16px;
            padding: 0 20px;
            text-align: center;
            color: var(--color-holder);
        }
    }
}
</style>
